import React from 'react'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { COMPANY_NAME } from '../globals';


const containerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: 60.170594952196375,
  lng: 24.94604635235237
};

function GoogleMapsComponent() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_Google_Maps_API
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
      >
        { /* Child components, such as markers, info windows, etc. */ }
        <Marker
            position={center}
            title={COMPANY_NAME}
        />

        <></>
      </GoogleMap>
  ) : <></>
}

export default React.memo(GoogleMapsComponent)